import { useQuery } from "@tanstack/react-query";

import { listAttendanceDays, listMyAttendanceDays } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { AttendanceWorkerDays, WeekRange } from "../types";
import { toAttendanceWorkerDays } from "../utils/map";

export function useAttendanceDays(range: WeekRange, enabled = true) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["attendance", "team", activeCanteiroId, range.from, range.to],
		enabled: enabled && activeCanteiroId != null,
		queryFn: async (): Promise<AttendanceWorkerDays[]> => {
			const { items } = await listAttendanceDays(activeCanteiroId as string, {
				from: range.from,
				to: range.to,
			});
			return items.map(toAttendanceWorkerDays);
		},
		staleTime: 30_000,
	});
}

export function useMyAttendanceDays(range: WeekRange, enabled = true) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["attendance", "me", activeCanteiroId, range.from, range.to],
		enabled: enabled && activeCanteiroId != null,
		queryFn: async (): Promise<AttendanceWorkerDays[]> => {
			const { items } = await listMyAttendanceDays(activeCanteiroId as string, {
				from: range.from,
				to: range.to,
			});
			return items.map(toAttendanceWorkerDays);
		},
		staleTime: 30_000,
	});
}
